module.exports = __webpack_public_path__ + "img/fx2.99409984.png";